import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2 } from 'lucide-react';
import Header from './components/Header2';
import Footer from './components/Footer2';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Profile = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Priya Sharma',
        email: 'priya.sharma@email.com',
        phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Priya+Sharma&size=200&background=FF6B35&color=fff',
        address: {
            street: '15, Fashion Lane, Bandra West',
            city: 'Mumbai',
            state: 'Maharashtra',
            pincode: '400050',
        },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData({ ...profileData, [parent]: { ...profileData[parent], [child]: value } });
        } else {
            setProfileData({ ...profileData, [name]: value });
        }
    };

    const handleSave = () => {
        devLog('Save profile:', profileData);
        setIsEditing(false);
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'orders', label: 'Orders', icon: Package },
        { id: 'wishlist', label: 'Wishlist', icon: Heart },
    ];

    const inputClass = "w-full px-4 py-3 text-sm bg-[#1A1A1A] border border-[#2A2A2A] text-white placeholder-[#525252] focus:outline-none focus:border-[#FF6B35] transition-colors font-['Montserrat']";
    const labelClass = "block text-xs font-semibold text-[#A3A3A3] uppercase tracking-wider mb-2 font-['Montserrat']";

    return (
        <div className="w-full min-h-screen bg-[#0A0A0A]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />
            <Header />

            <main className="pt-[90px] md:pt-[110px] pb-16">
                <div className="max-w-[1000px] mx-auto px-4 md:px-6">
                    <h1 className="text-2xl md:text-3xl font-bold text-white mb-8 font-['Montserrat'] uppercase">
                        My Account
                    </h1>

                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                        {/* Sidebar */}
                        <div className="lg:col-span-1">
                            {/* Avatar */}
                            <div className="text-center mb-6">
                                <div className="relative w-20 h-20 mx-auto mb-3">
                                    <img src={profileData.avatar} alt="Profile" className="w-full h-full rounded-full object-cover border-2 border-[#FF6B35]" />
                                    <button className="absolute -bottom-1 -right-1 w-7 h-7 bg-[#FF6B35] rounded-full flex items-center justify-center">
                                        <Camera className="w-3 h-3 text-white" />
                                    </button>
                                </div>
                                <p className="text-sm font-semibold text-white font-['Montserrat']">{profileData.fullName}</p>
                                <p className="text-xs text-[#525252] font-['Montserrat']">{profileData.email}</p>
                            </div>

                            {/* Tabs */}
                            <div className="space-y-1">
                                {tabs.map(({ id, label, icon: Icon }) => (
                                    <button
                                        key={id}
                                        onClick={() => id === 'orders' ? navigate('/template2/orders') : setActiveTab(id)}
                                        className={`w-full flex items-center gap-3 px-4 py-3 text-xs font-semibold uppercase tracking-wider transition-all duration-300 font-['Montserrat'] ${
                                            activeTab === id ? 'bg-[#FF6B35]/10 text-[#FF6B35] border-l-2 border-[#FF6B35]' : 'text-[#A3A3A3] hover:text-white hover:bg-[#1A1A1A]'
                                        }`}
                                    >
                                        <Icon className="w-4 h-4" /> {label}
                                    </button>
                                ))}
                                <button
                                    onClick={() => navigate('/template2/login')}
                                    className="w-full flex items-center gap-3 px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#A3A3A3] hover:text-[#FF6B35] transition-colors font-['Montserrat']"
                                >
                                    <LogOut className="w-4 h-4" /> Sign Out
                                </button>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="lg:col-span-3">
                            <div className="bg-[#1A1A1A] border border-[#2A2A2A] p-6 md:p-8">
                                <div className="flex items-center justify-between mb-6">
                                    <h2 className="text-base font-bold text-white font-['Montserrat'] uppercase tracking-wider">
                                        Personal Information
                                    </h2>
                                    <button
                                        onClick={() => isEditing ? handleSave() : setIsEditing(true)}
                                        className="inline-flex items-center gap-2 text-xs font-semibold text-[#FF6B35] uppercase tracking-wider hover:underline font-['Montserrat']"
                                    >
                                        {isEditing ? <><Save className="w-3 h-3" /> Save</> : <><Edit2 className="w-3 h-3" /> Edit</>}
                                    </button>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className={labelClass}>Full Name</label>
                                        {isEditing ? (
                                            <input name="fullName" value={profileData.fullName} onChange={handleChange} className={inputClass} />
                                        ) : (
                                            <p className="text-sm text-white font-['Montserrat'] py-3">{profileData.fullName}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className={labelClass}>Email</label>
                                        <p className="text-sm text-[#A3A3A3] font-['Montserrat'] py-3">{profileData.email}</p>
                                    </div>
                                    <div>
                                        <label className={labelClass}>Phone</label>
                                        {isEditing ? (
                                            <input name="phone" value={profileData.phone} onChange={handleChange} className={inputClass} />
                                        ) : (
                                            <p className="text-sm text-white font-['Montserrat'] py-3">{profileData.phone}</p>
                                        )}
                                    </div>
                                </div>

                                {/* Address */}
                                <div className="mt-8 pt-6 border-t border-[#2A2A2A]">
                                    <h3 className="text-sm font-bold text-white mb-4 font-['Montserrat'] uppercase tracking-wider">Address</h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="md:col-span-2">
                                            <label className={labelClass}>Street</label>
                                            {isEditing ? (
                                                <input name="address.street" value={profileData.address.street} onChange={handleChange} className={inputClass} />
                                            ) : (
                                                <p className="text-sm text-white font-['Montserrat'] py-3">{profileData.address.street}</p>
                                            )}
                                        </div>
                                        <div>
                                            <label className={labelClass}>City</label>
                                            {isEditing ? (
                                                <input name="address.city" value={profileData.address.city} onChange={handleChange} className={inputClass} />
                                            ) : (
                                                <p className="text-sm text-white font-['Montserrat'] py-3">{profileData.address.city}</p>
                                            )}
                                        </div>
                                        <div>
                                            <label className={labelClass}>State</label>
                                            {isEditing ? (
                                                <input name="address.state" value={profileData.address.state} onChange={handleChange} className={inputClass} />
                                            ) : (
                                                <p className="text-sm text-white font-['Montserrat'] py-3">{profileData.address.state}</p>
                                            )}
                                        </div>
                                        <div>
                                            <label className={labelClass}>Pincode</label>
                                            {isEditing ? (
                                                <input name="address.pincode" value={profileData.address.pincode} onChange={handleChange} className={inputClass} />
                                            ) : (
                                                <p className="text-sm text-white font-['Montserrat'] py-3">{profileData.address.pincode}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Change Password */}
                                <div className="mt-8 pt-6 border-t border-[#2A2A2A]">
                                    <Button variant="ghost" size="sm" className="gap-2">
                                        <Lock className="w-3 h-3" /> Change Password
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Profile;
